module.exports = __webpack_public_path__ + "img/text-con-9.b99f965e.png";